export const environment = {
    production: false,
    env: {
        name:"UAT",
        banner: "Test Environment"
    },
    logLevel: 'INFO',
    apiServer:  {
        webSocketlUrl: "wss://portalserver-uat.acimobills.com/portal",
        portalUrl: "https://portalserver-uat.acimobills.com/portal/api",
        authServerUrl: "https://portalserver-uat.acimobills.com/auth/api",
        rtpnUrl: "https://uat.walletron.click/rtpn/api"         
    },
    appSetting: {
    },
    brandMigration: {
        sourceRegions:  ["qa", "demo", "client2prod", "mbprod", "mobills2prod", "wuprod"],
        targetRegions: ["uat"]
    }
};
